import { render, staticRenderFns } from "./email-funnels-details.vue?vue&type=template&id=3860e40f&scoped=true&"
import script from "./email-funnels-details.vue?vue&type=script&lang=js&"
export * from "./email-funnels-details.vue?vue&type=script&lang=js&"
import style0 from "./email-funnels-details.vue?vue&type=style&index=0&id=3860e40f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3860e40f",
  null
  
)

export default component.exports